import intl from "react-intl-universal";
import {toJS} from "mobx";
import {getSnapshot} from "mobx-state-tree";

import {Task} from "../../stores/taskLists/gql/serverTypes";
import {TaskListUnitModelType} from "../../stores/taskLists/TaskListUnitModel";
import {TaskListModelType} from "../../stores/taskLists/TaskListModel";
import {TaskModel, TaskModelEnv} from "../../stores/taskLists/TaskModel";
import {snackBarRef} from "../../stores/snackbarRef";

export const copyTaskToUnit = async (
    task: Task,
    targetUnit: TaskListUnitModelType,
    taskModelEnv: TaskModelEnv,
    targetList?: TaskListModelType,
    index?: number,
) => {
    const src = toJS(task);
    const copyModel = TaskModel.create({
        isNew: true,
        hasChanges: true,
        taskListUnitId: targetUnit.id,
        taskListId: targetList ? targetList.id : null,
        name: src.name,
        description: src.description ?? '',
        scheduleRule: src.scheduleRule ?? {},
        relatedPage: src.relatedPage ?? null,
        config: src.config,
        images: src.images ?? [],
    }, taskModelEnv);

    await copyModel.save();
    const saved = copyModel.lastSavedObject;

    if (targetList && saved.id) {
        targetList.addChildId(saved.id, index);
        targetUnit.setTaskList(getSnapshot(targetList));
        await targetUnit.save();
    }

    snackBarRef.current?.enqueueSnackbar({
        variant: 'success',
        message: intl.get('task.duplicate.success').d('Task copied'),
    });
};
